import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { AddressForm } from '@bingads-webui-cc-react/address-form';
import { AddressTaxForm as TaxForm } from '@bingads-webui-cc-react/tax-form';

import { TaxCertificationPropTypes, TaxDataPropTypes } from './constants';

export class BusinessAddressTaxForm extends React.Component {
  state = { address: this.props.address };

  onAddressChange = (addressModel, addressObject) => {
    this.setState({ address: addressObject, isAddressValid: addressModel.isValid }, () => this.props.onAddressTaxFormChange(this.state));
  };

  onTaxValidate = ({ data, isValid, taxCertification }) => {
    this.setState({
      taxData: data,
      taxCertification,
      isTaxValid: isValid,
    }, () => this.props.onAddressTaxFormChange(this.state));
  };

  render() {
    const {
      id,
      i18n,
      address,
      taxData,
      mtTaxData,
      taxCertification,
      mtTaxCertification,
      countries,
      findCountries,
      findStates,
      isABLColombiaTaxEnabled,
      alwaysShowError,
      ownerAccountId,
      urlBuilder,
      showTaxCertLink,
      permissions,
      isSignupFlow,
      vatStatus,
      mtAddress,
    } = this.props;

    return (
      <div className="address-tax-form" id={`${id}_AddressFormContainer`}>
        <AddressForm
          id={`${id}_AddressForm`}
          i18n={i18n}
          countries={countries}
          findCountries={findCountries}
          findStates={findStates}
          model={address}
          onAddressChange={this.onAddressChange}
          showSectionLabel
          useDropdownList={this.props.useDropdownList}
          isSignupFlow={isSignupFlow}
          showLineByLineFormGroup
          showPlaceholder
          helpPopupId={this.props.helpPopupId}
          helpPopupAriaLabel={this.props.helpPopupAriaLabel}
          alwaysShowError={alwaysShowError}
        />

        { !_.isEmpty(countries) && (<TaxForm
          i18n={i18n}
          countries={countries}
          address={this.state.address}
          data={taxData}
          mtData={mtTaxData}
          taxCertification={taxCertification}
          mtTaxCertification={mtTaxCertification}
          onValidate={this.onTaxValidate}
          isABLColombiaTaxEnabled={isABLColombiaTaxEnabled}
          alwaysShowError={alwaysShowError}
          ownerAccountId={ownerAccountId}
          urlBuilder={urlBuilder}
          showTaxCertLink={showTaxCertLink}
          permissions={permissions}
          isSignupFlow={isSignupFlow}
          vatStatus={vatStatus}
          mtAdress={mtAddress}
          showLineByLineFormGroup
        />)}
      </div>
    );
  }
}

BusinessAddressTaxForm.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  findCountries: PropTypes.func.isRequired,
  findStates: PropTypes.func.isRequired,
  onAddressTaxFormChange: PropTypes.func.isRequired,
  address: PropTypes.shape({
    Line1: PropTypes.string,
    Line2: PropTypes.string,
    City: PropTypes.string,
    StateOrProvince: PropTypes.string,
    PostalCode: PropTypes.string,
    Country: PropTypes.string,
  }),
  mtAddress: PropTypes.shape({}),
  taxData: TaxDataPropTypes,
  mtTaxData: TaxDataPropTypes,
  taxCertification: TaxCertificationPropTypes,
  mtTaxCertification: TaxCertificationPropTypes,
  countries: PropTypes.arrayOf(PropTypes.shape({
    Code: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
  })),
  useDropdownList: PropTypes.bool,
  helpPopupId: PropTypes.string,
  helpPopupAriaLabel: PropTypes.string,
  alwaysShowError: PropTypes.bool,
  isABLColombiaTaxEnabled: PropTypes.bool,
  ownerAccountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  urlBuilder: PropTypes.shape({
    UrlBuilders: PropTypes.shape({}),
    UrlHelper: PropTypes.shape({}),
  }),
  showTaxCertLink: PropTypes.bool,
  permissions: PropTypes.shape({
    dynamic: PropTypes.objectOf(PropTypes.bool),
  }),
  isSignupFlow: PropTypes.bool,
  vatStatus: PropTypes.number,
};

BusinessAddressTaxForm.defaultProps = {
  address: {},
  mtAddress: {},
  taxData: [],
  mtTaxData: [],
  taxCertification: null,
  mtTaxCertification: null,
  countries: [],
  useDropdownList: false,
  helpPopupId: '',
  helpPopupAriaLabel: '',
  alwaysShowError: false,
  isABLColombiaTaxEnabled: false,
  ownerAccountId: null,
  urlBuilder: {
    UrlBuilders: {},
    UrlHelper: {},
  },
  showTaxCertLink: false,
  permissions: {
    dynamic: {},
  },
  isSignupFlow: false,
  vatStatus: null,
};
